import { render, staticRenderFns } from "./addProfile.vue?vue&type=template&id=6a8e7f94&scoped=true&"
import script from "./addProfile.vue?vue&type=script&lang=js&"
export * from "./addProfile.vue?vue&type=script&lang=js&"
import style0 from "./addProfile.vue?vue&type=style&index=0&id=6a8e7f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e7f94",
  null
  
)

export default component.exports